<template>
  <b-container>
    <b-row class="mt-5">
      <b-col class="text-center">
        <h3>{{ $t('PAGE_LIVE_title') }}</h3>
        <p>{{ $t('PAGE_LIVE_subtitle') }}</p>
      </b-col>
    </b-row>

    <b-row class="my-3">
      <b-col>
        <b-row v-for="(liveStream, key) in liveStreams.filter(ls => !ls.past).reverse()" :key="`present_${key}`" class="mt-5">
          <b-col>
            <b-row>
              <b-col cols="4">
                <LazyImage
                  :src="liveStream.image"
                  :width="liveStream.imageWidth"
                  :height="liveStream.imageHeight"
                  :overlay="false"
                />
              </b-col>
              <b-col>
                <h5>
                  {{liveStream.title}} 
                  <!--<small class="pl-4  text-muted">{{$moment(liveStream.timestamp).format('ddd DD. MMMM, HH:mm')}}</small>-->
                </h5>
                <vue-markdown :source="liveStream.description" />

                <div class="mt-2"/>
                <b-button :href="liveStream.url" variant="primary" size="sm">{{ $t('PAGE_LIVE_to_stream') }}</b-button><!-- <span class="text-muted ml-2">{{ $t('PAGE_LIVE_to_stream_time') }} {{ $moment(liveStream.timestamp).fromNow() }}</span>-->
  

              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-if="liveStreams.filter(ls => ls.past).length">
        
          <b-col class="text-center mt-5 border-bottom">
            <h6>{{ $t('PAGE_LIVE_past_streams') }}</h6>
          </b-col>
        </b-row>


        <b-row v-for="(liveStream, key) in liveStreams.filter(ls => ls.past)" :key="key" class="my-5">
          <b-col>
            <b-row>
              <b-col cols="4">
                <LazyImage
                  :src="liveStream.image"
                  :width="liveStream.imageWidth"
                  :height="liveStream.imageHeight"
                  :overlay="false"
                />
              </b-col>
              <b-col>
                <h5>
                  {{liveStream.title}} 
                  <!--<small class="pl-4 text-muted">{{$moment(liveStream.timestamp).format('ddd DD MMM - HH:mm')}}</small>-->
                </h5>
                <vue-markdown :source="liveStream.description" />

                <div class="mt-2"/>
                <b-button :href="liveStream.url" variant="outline-primary" size="sm">{{ $t('PAGE_LIVE_to_past_stream') }}</b-button>
  
               </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import VueMarkdown from 'vue-markdown';
import LazyImage from '@/components/LazyImage';

export default {
  name: 'home',
  data() {
    return {
      
    };
  },
  components: {
    VueMarkdown,
    LazyImage
  },
  asyncData({ store, route }) {
    store.dispatch('getLiveStreams');
  },
  computed: {
    ...mapGetters([
      'liveStreams',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import '/../theme';
.chevron {
  transition: transform 0.4s;
  color: theme-color('green');
}

.isOpen {
  transform: rotateZ(-180deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/Live.vue